import { SeoRenderer } from "../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({
            title: allMessage["article.rhytname.hello.title"],
            description: allMessage["article.rhytname.hello.description"],
            allMessage,
            lang,
        });
    },
};
